/**
 * Brand / site configuration driven entirely by Vite env vars.
 * Set these in Netlify site environment variables (or .env locally).
 *
 * VITE_SITE_NAME        — display name, e.g. "Park Confetti"
 * VITE_SITE_URL         — canonical URL, e.g. "https://parkconfetti.com"
 * VITE_SUPPORT_EMAIL    — customer support address
 * VITE_INFO_EMAIL       — general contact address shown in footer / emails
 */

export const SITE_NAME: string =
  import.meta.env.VITE_SITE_NAME || 'Park Confetti';

export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL || 'https://parkconfetti.com').replace(/\/$/, '');

export const SUPPORT_EMAIL: string =
  import.meta.env.VITE_SUPPORT_EMAIL || `support@${new URL(SITE_URL).hostname}`;

export const INFO_EMAIL: string =
  import.meta.env.VITE_INFO_EMAIL || `info@${new URL(SITE_URL).hostname}`;
